import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/cdk/stepper';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponentBusinessuser implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  selected = -1;
  page = null;
  type: string = "";
  pageComponents = {
    pageIndex: 0,
    pageSize: 8
  }
  stepperOrientation: Observable<StepperOrientation>;
  selectedBusinessuser: boolean = false;
  public genderOptions = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]
  finishedLoadingUsers: boolean = false;
  addForm: UntypedFormGroup;
  addressForm: UntypedFormGroup;
  accountForm: UntypedFormGroup;
  serachFrom: UntypedFormGroup;
  dataSource: MatTableDataSource<BusinessUserResource>;
  // 'number',


  displayedColumns = ['menu', 'user'];
  clientID:number = environment.clientID;
  constructor(
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private overlayservice: OverlayService) {

    this.route.params.subscribe(params => {
      this.type = params['type'];
    })
    

    this.addForm = this.fb.group({
      autoActivation: [false],
    })

    this.serachFrom = this.fb.group({
      searchTerm: [''],
    })



    this.accountForm = this.fb.group({
      username: ['', []],
      customerNumber: [''],
      gender: ['', [Validators.required]],
      title: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      birthday: ['', [Validators.required]],
      phone: ['', []],
    })

    this.addressForm = this.fb.group({
      street: ['', [Validators.required]],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
    })

    //change the orientation of the stepper based on th screen with
    this.stepperOrientation = this.breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    if(environment.clientID == 113){

      this.finishedLoadingUsers = true;
    }else{
      this.businessuserService.getERPDataForNewCustomer(this.pageComponents.pageIndex, this.pageComponents.pageSize, this.serachFrom.value.searchTerm).subscribe((erp: PagedResources<BusinessUserResource>) => {
        console.log("ERP Search: ", erp)
        this.page = erp.page
        this.dataSource = new MatTableDataSource(erp.content);
        this.finishedLoadingUsers = true;
      })
    }


    // this.businessuserService.getERPDataForNewCustomer(this.pageComponents.pageIndex, this.pageComponents.pageSize, this.serachFrom.value.searchTerm).subscribe((erp: PagedResources<BusinessUserResource>) => {
    //   console.log(erp)
    //   this.page = erp.page
    //   this.dataSource = new MatTableDataSource(erp.content);
    //   this.finishedLoadingUsers = true;
    // })
  }

  createUser() {
    this.addForm.markAllAsTouched();
    if (this.addForm.invalid) {
      return
    }

    let t = {
      "clientId": null,
      "internalId": null,
      "publicId": null,
      "account": {
        "username": this.accountForm.value.username != '' ? this.accountForm.value.username : null
      },
      "person": {
        "title": this.accountForm.value.title,
        "firstName": this.accountForm.value.firstName,
        "lastName": this.accountForm.value.lastName,
        "birthday": this.accountForm.value.birthday,
        "gender": this.accountForm.value.gender,
      },
      "address": {
        "street": this.addressForm.value.street,
        "postcode": this.addressForm.value.postcode,
        "city": this.addressForm.value.city,
        "countryCode": "DE",
        "location": null
      },
     // "email": this.accountForm.value.username,
      "phone": this.accountForm.value.phone,
      "mobile": this.accountForm.value.phone,
      "businessRole": "MAINCUSTOMER",
      "customerNumber": this.accountForm.getRawValue().customerNumber,
      "mainCustomerPublicId": null,
      "contactChannels": [],
      "supplyContracts": [],
      "accountProperties": [],
      "links": []
    }

    this.businessuserService.activateERPUser(this.addForm.value.autoActivation, t).subscribe((val: BusinessUserResource) => {
      this.overlayservice.openSnackBar("Nutzer erfolgreich angelegt!")
      this.router.navigate(['caseworker/dashboard'], { queryParams: {  searchTerm: val.customerNumber } } )
    })

  }


  loadPage(event?: PageEvent) {
    this.pageComponents.pageIndex = event.pageIndex;
    this.pageComponents.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  // search(pageIndex, pageSize) {
  //   this.businessuserService.getERPDataForNewCustomer(pageIndex, pageSize, this.serachFrom.value.searchTerm).subscribe((push: PagedResources<BusinessUserResource>) => {
  //     this.page = push.page
  //     this.dataSource = new MatTableDataSource(push.content);
  //   })
  // }

  search(pageIndex, pageSize) {
    if(environment.clientID == 113){
      console.log(1)
      this.businessuserService.getERPDataForNewCustomerLemgo(pageIndex, pageSize, this.serachFrom.value.searchTerm).subscribe((push: PagedResources<BusinessUserResource>) => {
        console.log("ERP Search: ", push)
        this.page = push.page
        this.dataSource = new MatTableDataSource(push.content);
      })

    }else{
      console.log(2)
      this.businessuserService.getERPDataForNewCustomer(pageIndex, pageSize, this.serachFrom.value.searchTerm).subscribe((push: PagedResources<BusinessUserResource>) => {
        console.log("ERP Search: ", push)
        this.page = push.page
        this.dataSource = new MatTableDataSource(push.content);
      })
    }

  }


  setActiveCustomer(cu) {
    this.selectedBusinessuser = true;
    if (this.accountForm.value.lastName != '') {
      this.stepper.reset()
    }
    this.accountForm.patchValue({
      customerNumber: cu.customerKey,
      username: cu.customer.email,
      title: cu.customer.person?.title,
      firstName: cu.customer.person.firstName,
      lastName: cu.customer.person.lastName,
      birthday: cu.customer.person.birthday,
      gender: cu.customer.person.gender,
      phone: cu.customer.mobile
    })
    this.addressForm.patchValue({
      street: cu.customer.address?.street,
      postcode: cu.customer.address?.postcode,
      city: cu.customer.address?.city,
    })
    this.accountForm.controls.customerNumber.disable();
  }
  filterUsers() {
    // this.businessuserService.getERPDataForNewCustomer(0, 12, this.serachFrom.value.searchTerm).subscribe((push: PagedResources<BusinessUserResource>) => {
    //   this.page = push.page
    //   this.dataSource = new MatTableDataSource(push.content);
    // })

    if(environment.clientID == 113){
      this.businessuserService.getERPDataForNewCustomerLemgo(0, 12, this.serachFrom.value.searchTerm).subscribe((erp: PagedResources<BusinessUserResource>) => {
        console.log("ERP Search: ", erp)
        this.page = erp.page
        this.dataSource = new MatTableDataSource(erp.content);
        this.finishedLoadingUsers = true;
      })

    }else{
      this.businessuserService.getERPDataForNewCustomer(0,12, this.serachFrom.value.searchTerm).subscribe((erp: PagedResources<BusinessUserResource>) => {
        console.log("ERP Search: ", erp)
        this.page = erp.page
        this.dataSource = new MatTableDataSource(erp.content);
        this.finishedLoadingUsers = true;
      })
    }
  }
}
